import Reveal from "@/components/Reveal";
import { Check } from "lucide-react";
import { IMAGES } from "@/data/site";

const INSURERS = [
  "Pacific Blue Cross",
  "Manulife",
  "Sun Life",
  "Canada Life",
  "Green Shield",
  "Desjardins",
];

export default function Billing() {
  return (
    <section id="billing" data-testid="billing-section" className="relative overflow-hidden bg-pine py-24 text-bone lg:py-32">
      <img
        src={IMAGES.texture}
        alt=""
        aria-hidden
        className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-10"
      />
      <div className="relative mx-auto grid max-w-[1400px] grid-cols-1 gap-16 px-6 lg:grid-cols-12 lg:px-12">
        <div className="lg:col-span-6">
          <Reveal>
            <p className="mb-6 flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-clay">
              <span className="h-px w-10 bg-clay" /> Direct billing
            </p>
            <h2 className="font-serif text-4xl font-light leading-tight tracking-tighter sm:text-5xl" data-testid="billing-heading">
              We bill your insurer directly. You just show up.
            </h2>
            <p className="mt-8 max-w-md text-base leading-relaxed text-bone/70">
              Most extended health plans cover registered massage therapy in BC.
              Bring your plan details to your first visit and we'll submit the
              claim on your behalf — no paperwork, no waiting for reimbursement.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-5 lg:col-start-8">
          <Reveal delay={0.15}>
            <ul className="grid grid-cols-1 gap-x-8 sm:grid-cols-2" data-testid="billing-insurer-list">
              {INSURERS.map((ins) => (
                <li key={ins} className="flex items-center gap-3 border-b border-bone/15 py-4 text-sm tracking-wide text-bone/85">
                  <Check className="h-4 w-4 shrink-0 text-clay" /> {ins}
                </li>
              ))}
            </ul>
            <p className="mt-8 text-xs uppercase tracking-[0.2em] text-bone/50" data-testid="billing-note">
              ICBC & WorkSafeBC patients welcome — you submit receipts for reimbursement yourself
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
